var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Header" },
    [
      _c("div", { staticClass: "logo" }, [
        _c("a", { attrs: { href: "javascript:;" } }, [
          _c("img", {
            attrs: {
              src: require("../assets/images/logo.png"),
              alt: "yly-logo"
            }
          }),
          _vm._v(" "),
          _c("h1", [_vm._v(_vm._s(_vm.myOption.name))])
        ])
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "logout" },
        [
          _c("li", [
            _c(
              "a",
              { attrs: { href: "javascript:;" }, on: { click: _vm.setMyInfo } },
              [_vm._v(_vm._s(_vm.$store.state.user.info.nickName))]
            )
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("|")]),
          _vm._v(" "),
          _vm.sysConfigPower
            ? [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:;" },
                      on: { click: _vm.openSysConfigDialog }
                    },
                    [_vm._v("系统配置")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("|")])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.operatePower
            ? [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:;" },
                      on: { click: this.getOperate }
                    },
                    [_vm._v("运营配置")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("|")])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isRefresh
            ? [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:;" },
                      on: { click: _vm.refreshCache }
                    },
                    [_vm._v("刷新缓存")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("|")])
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              { attrs: { href: "javascript:;" }, on: { click: _vm.logout } },
              [_vm._v("退出")]
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading"
            }
          ],
          attrs: {
            title: "修改个人信息",
            visible: _vm.isMyInfo,
            width: "40%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.isMyInfo = $event
            },
            close: function($event) {
              return _vm.resetForm("form")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "66px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "姓名", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "新密码", prop: "passWord" } },
                [
                  _c("el-input", {
                    attrs: { "show-password": "" },
                    on: { input: _vm.setIsRequired },
                    model: {
                      value: _vm.form.passWord,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "passWord", $$v)
                      },
                      expression: "form.passWord"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "旧密码", prop: "passWordOld" } },
                [
                  _c("el-input", {
                    attrs: { "show-password": "" },
                    on: { input: _vm.setIsRequired },
                    model: {
                      value: _vm.form.passWordOld,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "passWordOld", $$v)
                      },
                      expression: "form.passWordOld"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("form")
                        }
                      }
                    },
                    [_vm._v("提交")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "系统配置",
            visible: _vm.showSysConfigDialog,
            width: "550px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showSysConfigDialog = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.sysConfigForm, "label-width": "115px" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "日志流开关" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": "1", "inactive-value": "0" },
                    model: {
                      value: _vm.logDetailConfig.enable,
                      callback: function($$v) {
                        _vm.$set(_vm.logDetailConfig, "enable", $$v)
                      },
                      expression: "logDetailConfig.enable"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.logDetailConfig.enable === "1",
                      expression: "logDetailConfig.enable === '1'"
                    }
                  ],
                  class: { "is-error": _vm.logDetailEndTimeError },
                  attrs: { label: "日志流到期时间" }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      pickerOptions: _vm.pickerOptions,
                      placeholder: "到期时间"
                    },
                    on: { change: _vm.checkEndTime },
                    model: {
                      value: _vm.logDetailConfig.endTime,
                      callback: function($$v) {
                        _vm.$set(_vm.logDetailConfig, "endTime", $$v)
                      },
                      expression: "logDetailConfig.endTime"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.logDetailConfig.enable === "1",
                      expression: "logDetailConfig.enable === '1'"
                    }
                  ],
                  class: { "is-error": _vm.logDetailSamplingRateError },
                  attrs: { label: "日志流采样率" }
                },
                [
                  _c("el-input-number", {
                    attrs: {
                      precision: 2,
                      step: 0.05,
                      min: 0.01,
                      max: 100,
                      placeholder: "0~100"
                    },
                    model: {
                      value: _vm.logDetailConfig.samplingRate,
                      callback: function($$v) {
                        _vm.$set(_vm.logDetailConfig, "samplingRate", $$v)
                      },
                      expression: "logDetailConfig.samplingRate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _vm.sysConfigUpdatePower
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmitSysConfig }
                        },
                        [_vm._v("确定")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading"
            }
          ],
          attrs: {
            title: "运营配置",
            visible: _vm.isOperateVisible,
            width: "550px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.isOperateVisible = $event
            },
            close: function($event) {
              return _vm.resetForm("form")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "220px",
                center: ""
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "CTR预估冷启动周期", prop: "ctrColdCycle" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        type: "number",
                        size: "medium",
                        disabled: !_vm.operateUpdatePower,
                        onKeypress:
                          "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))"
                      },
                      model: {
                        value: _vm.form.ctrColdCycle,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "ctrColdCycle", _vm._n($$v))
                        },
                        expression: "form.ctrColdCycle"
                      }
                    },
                    [
                      _c("div", { attrs: { slot: "append" }, slot: "append" }, [
                        _vm._v("分钟")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "代码位+创意: 启动时长达到该时限后，CTR预估的冷启动结束。与点击数的冷启动结束阈值联动，满足其一则结束CTR预估",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "CVR预估冷启动周期", prop: "cvrColdCycle" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        type: "number",
                        size: "medium",
                        disabled: !_vm.operateUpdatePower,
                        onKeypress:
                          "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))"
                      },
                      model: {
                        value: _vm.form.cvrColdCycle,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cvrColdCycle", _vm._n($$v))
                        },
                        expression: "form.cvrColdCycle"
                      }
                    },
                    [
                      _c("div", { attrs: { slot: "append" }, slot: "append" }, [
                        _vm._v("分钟")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "代码位+创意: 启动时长达到该时限后，CVR预估的冷启动结束。与激活数的冷启动结束阈值联动，满足其一则结束CVR预估",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "点击数的冷启动结束阈值",
                    prop: "clickThreshold"
                  }
                },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        type: "number",
                        size: "medium",
                        disabled: !_vm.operateUpdatePower,
                        onKeypress:
                          "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))"
                      },
                      model: {
                        value: _vm.form.clickThreshold,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "clickThreshold", _vm._n($$v))
                        },
                        expression: "form.clickThreshold"
                      }
                    },
                    [
                      _c("div", { attrs: { slot: "append" }, slot: "append" }, [
                        _vm._v("次")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "代码位+创意: 点击数达到该值后，CTR预估的冷启动结束。与CTR预估冷启动周期联动，满足其一则结束CTR预估",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "激活数的冷启动结束阈值",
                    prop: "activateThreshold"
                  }
                },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        type: "number",
                        size: "medium",
                        disabled: !_vm.operateUpdatePower,
                        onKeypress:
                          "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))"
                      },
                      model: {
                        value: _vm.form.activateThreshold,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "activateThreshold", _vm._n($$v))
                        },
                        expression: "form.activateThreshold"
                      }
                    },
                    [
                      _c("div", { attrs: { slot: "append" }, slot: "append" }, [
                        _vm._v("次")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "代码位+创意: 激活数达到该值后，CVR预估的冷启动结束。与CVR预估冷启动周期联动，满足其一则结束CVR预估",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "CTR冷启动阈值", prop: "ctrThreshold" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      type: "text",
                      size: "medium",
                      disabled: !_vm.operateUpdatePower,
                      oninput:
                        "event.target.value = event.target.value.match(/^\\d*(\\.?\\d{0,2})/gi)[0] || ''"
                    },
                    model: {
                      value: _vm.form.ctrThreshold,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "ctrThreshold", $$v)
                      },
                      expression: "form.ctrThreshold"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content: "代码位+创意: 冷启动阶段的CTR阈值",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "CVR冷启动阈值", prop: "cvrThreshold" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      type: "text",
                      size: "medium",
                      disabled: !_vm.operateUpdatePower,
                      oninput:
                        "event.target.value = event.target.value.match(/^\\d*(\\.?\\d{0,2})/gi)[0] || ''"
                    },
                    model: {
                      value: _vm.form.cvrThreshold,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cvrThreshold", $$v)
                      },
                      expression: "form.cvrThreshold"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content: "代码位+创意: 冷启动阶段的CVR阈值",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "CTR预估周期", prop: "ctrExpectedCycle" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        type: "number",
                        size: "medium",
                        disabled: !_vm.operateUpdatePower,
                        onKeypress:
                          "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))"
                      },
                      model: {
                        value: _vm.form.ctrExpectedCycle,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "ctrExpectedCycle", _vm._n($$v))
                        },
                        expression: "form.ctrExpectedCycle"
                      }
                    },
                    [
                      _c("div", { attrs: { slot: "append" }, slot: "append" }, [
                        _vm._v("分钟")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "代码位+创意: CTR预估的取数时间周期(最大1440分钟)，每分钟更新一次CTR",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "CVR预估周期", prop: "cvrExpectedCycle" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        type: "number",
                        size: "medium",
                        disabled: !_vm.operateUpdatePower,
                        onKeypress:
                          "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))"
                      },
                      model: {
                        value: _vm.form.cvrExpectedCycle,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cvrExpectedCycle", _vm._n($$v))
                        },
                        expression: "form.cvrExpectedCycle"
                      }
                    },
                    [
                      _c("div", { attrs: { slot: "append" }, slot: "append" }, [
                        _vm._v("分钟")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "代码位+创意: CVR预估的取数时间周期(最大1440分钟)，每分钟更新一次CVR",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "广告填充概率", prop: "adFillRate" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      type: "number",
                      size: "medium",
                      disabled: !_vm.operateUpdatePower,
                      onKeypress:
                        "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))"
                    },
                    model: {
                      value: _vm.form.adFillRate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "adFillRate", _vm._n($$v))
                      },
                      expression: "form.adFillRate"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content: "DSP参竞概率",
                        placement: "right"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-info" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.operateUpdatePower
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.setOperate }
                        },
                        [_vm._v("提交")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = Mj/J
// module chunks = 1